// Work.js
import React from 'react';
import './Work.css';

const Work = () => {
  return (
    <div className='work'>
      <h3>Work Experience</h3>
      <div className='work-item'>
        <div className='work-title'>Web development Intern</div>
        <div className='working-company'>
          Company: CodSoft,      April 2024 - May 2024
        </div>
        <div className='work-description'>
          • Enhanced a real-time editing tool of CodSoft with React.js and Node.js, improving interaction and performance.<br />
          •	Added cursor synchronization, versioning, and user indicators to boost collaboration.<br />
          •	Developed a robust backend using MongoDB, enhancing system reliability and data integrity for high user concurrency.

        </div>
      </div>
      <div className='work-item'>
        <div className='work-title'>Software Development Engineering Intern</div>
        <div className='working-company'>
          Company: ITJOBXS,      June 2023 - Nov 2023
        </div>
        <div className='work-description'>
          • Frontend Optimization: Minify and combine CSS/JS, use lazy loading, and employ a CDN for faster loading times.<br />
          • Backend Optimization: Optimize database queries, utilize caching, and implement asynchronous processing for improved performance.<br />
          • User Authentication and Bot Detection: Employ multi-factor authentication, rate limiting, and web application firewalls for enhanced security.<br />
          • Google ReCAPTCHA Integration: Integrate ReCAPTCHA effectively to prevent bot activity while maintaining user experience.<br />
        </div>
      </div>
      <div className='work-item'>
        <div className='work-title'>Data Analyst Trainee</div>
        <div className='working-company'>
          Company: Trinity,      Oct 2022 - Dec 2022
        </div>
        <div className='work-description'>
          • Developed data analytics processes for Instagram user analytics, operations and Metric analytics and, hiring process analytics.<br />
          •	Analyzed IMDB movie data and conducted bank loan case studies to derive actionable insights.<br />
          •	Worked on various data analytics techniques for informed decision-making and business optimization process.<br />
        </div>
      </div>
      <div className='work-item'>
        <div className='work-title'>Machine learning Intern</div>
        <div className='working-company'>
          Company: Cranes Varisty Pvt Ltd,      Sept 2022 - Oct 2022
        </div>
        <div className='work-description'>
          • Analyzed and visualized complex data, gaining insights and honing data manipulation skills.<br />
          • Developed and executed a Movie recommendation system, showcasing algorithmic understanding.<br />
          • Employed Python (NumPy, Pandas), SQL, Excel, and Google Colab to drive data-driven decisions.
          <br />
        </div>
      </div>
    </div>
  );
};

export default Work;
